import {EnumLanguage} from "../EnumLanguage";

export const UXRecovery = {
    title: {
        [EnumLanguage.ru]: 'Восстановление пароля',
        [EnumLanguage.en]: 'Password recovery',
        [EnumLanguage.cn]: '找回密码'

    },
    recoverySuccess: {
        header: {
            [EnumLanguage.ru]: 'Письмо отправлено!',
            [EnumLanguage.en]: 'Letter sent!',
            [EnumLanguage.cn]: '信已寄出！'
        },
        text: {
            [EnumLanguage.ru]: 'Осталось только перейти по ссылке в письме на Вашей электронной почте!',
            [EnumLanguage.en]: 'All you have to do is follow the link in your email!',
            [EnumLanguage.cn]: '您所要做的就是点击电子邮件中的链接！'
        }
    }
}